export const AppColor = {
  "Background/Light Grey": "#F6F9FC",

  "Text/Dark Grey": "#767676",
  "Text/Placeholder": "#637381",
  "Text/Black": "#000000",
  "Background/Dark Grey": "#E0E0E0",

  "Other/Success": "#4CAF4F",
  //
  "Background/Disable": "#C5C5C5",
  "Background/Background": "#EAEAEA",
  "Other Light/Warning": "#F8E6A4",
  "Other/Info": "#0084FF",
  "Other/Danger": "#D93636",
  "Other/Warning": "#D97706",
  "Text/White": "#FFFFFF",
  "Text/Secondary": "#333333",
  "Text/Primary": "#000000",
  "Text/Line": "#7C7C7C",
  "Primary/Primary Text": "#00A971",
  "Primary/Line": "#009262",
  "Primary/Hover": "#009262",
  "White / White": "#FFFFFF",
  "Primary/Primary": "#00A971",
  "Secondary/Hover": "#009262",
  "Secondary  Light/Background": "#EDF9F5",
  "Schemes/On Surface": "#49454F",
  "Upload/Background": "#FAFAFA",
  "Upload/Border": "#DADCE0",
  "Other Light/Info": "#B9D9F9",
  "Background/Black": "#212121",
};
